const defaultStyles = {
  boxSizing: 'box-sizing: border-box;',
  fontSmoothing: `
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  `,
  ellipsis: `
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `
};

export { defaultStyles };
//# sourceMappingURL=defaultStyles.js.map
